import { VFC, useState, useEffect, useCallback } from 'react'
import './assets/globals.scss'

import { BaseButton } from './components/atoms/BaseButton'
import { ManipulationPanel } from './components/organisms/ManipulationPanel'
import { Field } from './components/template/Field'
import { Navigation } from './components/template/Navigation'

import { initialFields, initialFieldValue, generateFoodPosition } from './utils/field.index'
import { SETPOSITION } from './utils/types/field.index.types'

import { GameStatus, isGameOver } from './utils/gameStatus.index'
import { Direction, OppositeDirection, DirectionKeyCodeMap, Delta } from './utils/directionKey.index'

const defaultInterval = 1000;
let timer: any = undefined
const unsubscribe = () => {
  if (!timer) {
    return
  }
  clearInterval(timer);
}

const defaultDifficulty: number = 3
const Difficulty = [1000, 500, 100, 50, 10]

const App: VFC = () => {
  const [fields, setFields] = useState<Array<string[]>>(initialFields(initialFieldValue.size, initialFieldValue.position));
  const [status, setStatus] = useState<string>(GameStatus.init);
  const [direction, setDirection] = useState<string>(Direction.up);
  const [tick, setTick] = useState<number>(0);
  const [difficulty, setDifficulty] = useState(defaultDifficulty)

  const [body, setBody] = useState<SETPOSITION[]>([])


  const handleMoving = useCallback((): boolean => {
    const { x, y } = body[0]
    const delta = Delta[direction];
    if (body !== undefined) {
      const newPosition = {
        x: x + delta.x,
        y: y + delta.y,
      };
      if (isGameOver(fields.length, newPosition)) return false
      const newBody = [...body]
      if (fields[newPosition.y][newPosition.x] !== 'food') {
        const removingTrack = newBody.pop();
        if (removingTrack !== undefined) {
          fields[removingTrack.y][removingTrack.x] = '';
        }
      } else {
        const newPosition = [...newBody];
        const food = generateFoodPosition(fields.length, newPosition[0]);
        fields[food.y][food.x] = 'food'
      }
      fields[newPosition.y][newPosition.x] = 'snake';
      newBody.unshift(newPosition);

      setBody(newBody);
      setFields(fields);
      return true
    }
    return false
  }, [body, fields, direction]);
  // const handleMoving = ():boolean => {
  //   const { x, y } = body[0]
  //   const delta = Delta[direction];
  //   if (body !== undefined) {
  //     const newPosition = {
  //       x: x + delta.x,
  //       y: y + delta.y,
  //     };
  //     if (isGameOver(fields.length, newPosition)) return false
  //     const newBody = [...body]
  //     if (fields[newPosition.y][newPosition.x] !== 'food') {
  //       const removingTrack = newBody.pop();
  //       if (removingTrack !== undefined) { 
  //         fields[removingTrack.y][removingTrack.x] = '';
  //       }
  //     } else {
  //       const newPosition = [...newBody];
  //       const food = generateFoodPosition(fields.length, newPosition[0]);
  //       fields[food.y][food.x] = 'food'
  //     }
  //     fields[newPosition.y][newPosition.x] = 'snake';
  //     newBody.unshift(newPosition);

  //     setBody(newBody);
  //     setFields(fields);
  //     return true
  //   }
  //   return false
  // };

  useEffect(() => {
    setBody([initialFieldValue.position]);
    const interval = Difficulty[difficulty - 1];
    timer = setInterval((): void => {
      setTick(tick => tick + 1);
    }, interval)
    return unsubscribe
  }, [difficulty])

  useEffect(() => {
    if (body.length === 0 || status !== GameStatus.playing) {
      return
    }
    const canContinue = handleMoving();
    if (!canContinue) {
      setStatus(GameStatus.gameover)
    }
  }, [tick, status, body, handleMoving]);

  const onGameStart = () => setStatus(GameStatus.playing);

  const onGameRestart = () => {
    timer = setInterval(() => {
      setTick(tick => tick + 1);
    }, defaultInterval)
    setStatus(GameStatus.init);
    setDirection(Direction.up);
    setBody([initialFieldValue.position]);
    setFields(initialFields(initialFieldValue.size, initialFieldValue.position));
  }

  const onGameStop = () => setStatus(GameStatus.suspended)

  const onChangeDirection = useCallback((newDirection: string) => {
    if (status !== GameStatus.playing) {
      return direction
    }
    if (typeof (direction) === 'string') {
      if (OppositeDirection[direction] === newDirection) {
        return
      }
    }
    setDirection(newDirection)
  }, [direction, status])

  useEffect(() => {
    const handleKeyDown = (event: any) => {
    const { code } = event;
      const newDirection = DirectionKeyCodeMap[code];
      if (!newDirection) {
        return;
      }

      onChangeDirection(newDirection);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [onChangeDirection])

  const displayGameStatusButton = (): string => {
    if (status === 'init') return 'start'
    else if (status === 'playing') return 'stop'
    else if (status === 'suspended') return 'start'
    else if (status === 'gameover') return 'gameover'
    else return '';
  }

  const changeActionGameButtom = (): void => {
    console.log(status);
    if (status === 'init') return onGameStart()
    else if (status === 'playing') return onGameStop()
    else if (status === 'suspended') return onGameStart()
    else if (status === 'gameover') return onGameRestart()
  }

  const onChangeDifficulty = useCallback((difficulty): void => {
     if (status !== GameStatus.init) {
       return
     }
     if (difficulty < 1 || difficulty > difficulty.length) {
       return
     }
     setDifficulty(difficulty)
  }, [status])
  
  return (
    <>
      <div>
        <header className="header">
          <div className="title-container">
            <h1 className="title">Snake Game</h1>
          </div>
          <Navigation
            length={ body.length }
            difficulty={ difficulty }
            eventClick={ onChangeDifficulty }
          />
        </header>
        <main>
          <Field fields={ fields } />
        </main>
        <footer className="footer">
          <BaseButton
            label={displayGameStatusButton()}
            eventClick={changeActionGameButtom}
          />
          <ManipulationPanel onChange={ onChangeDirection } />
        </footer>
      </div>
    </>
  );
}

export default App;
